export default __webpack_public_path__ + "static/sm-poster3-cc0261ba1909efb33b167d265b1f902e.png";